import type { ThemePreference } from "@/hooks/useTheme";
import type { SpeakMode } from "@/lib/speech/voiceSettings";

export const THEME_OPTIONS: { value: ThemePreference; label: string; icon: string }[] = [
  { value: "light", label: "Light", icon: "☀️" },
  { value: "dark", label: "Dark", icon: "🌙" },
  { value: "system", label: "System", icon: "💻" },
  /** Warm charcoal/amber dark alternative — placeholder label; value stays `"special"`. */
  { value: "special", label: "Special", icon: "✨" },
];

export const SPEAK_OPTIONS: { value: SpeakMode; label: string; description: string }[] = [
  { value: "answers", label: "Answers", description: "Full KB responses only" },
  { value: "help", label: "Help", description: "Short coaching prompts" },
  { value: "all", label: "All", description: "Both responses and prompts" },
];
